import React from 'react';
import I18n from 'i18n-js';

import { RCAlertBox } from '@reverbdotcom/cadence/components';

import {
  core_apimessages_Money as IMoney,
  core_apimessages_NegotiationParty as NegotiationParty,
} from '../rql';

import { canViewListingPriceRecommendations } from '../user_context_helpers';
import { B_STOCK, BRAND_NEW, NON_FUNCTIONING } from '../condition_helpers';


interface IProps {
  offerPrice?: IMoney;
  recommendedLowPrice: IMoney;
  recommendedHighPrice: IMoney;
  belowLowballThreshold?: boolean;
  party: NegotiationParty;
}

export function priceRecommendationCanBeShown(user, shopCurrency, listing) {
  const canViewPriceRecommendation = user && shopCurrency && canViewListingPriceRecommendations(user, shopCurrency);
  if (!canViewPriceRecommendation) {
    return false;
  }

  const isExcludedCondition = [BRAND_NEW, NON_FUNCTIONING, B_STOCK].includes(listing?.condition?.conditionSlug);
  return listing?.price?.amountCents &&
    listing.canonicalProductId &&
    !isExcludedCondition &&
    listing.priceRecommendation?.priceHigh?.amountCents &&
    (listing.priceRecommendation.priceLow?.amountCents || 0) > 0 &&
    listing.price.amountCents <= listing.priceRecommendation.priceHigh.amountCents;
}

export function EstimatedValueAlert({ recommendedLowPrice, recommendedHighPrice, party, offerPrice = undefined, belowLowballThreshold = false }: IProps) {
  if (!recommendedLowPrice?.amountCents || !recommendedHighPrice?.amountCents) { return null; }

  const isSeller = party === NegotiationParty.SELLER;
  const outOfRange = offerPrice && (offerPrice.amountCents < recommendedLowPrice.amountCents);

  let alertType, alertMessage;
  if (belowLowballThreshold && !isSeller) {
    alertType = 'error';
    alertMessage = I18n.t('commons.offers.estimatedValueAlert.belowLowballThreshold');
  } else if (outOfRange) {
    alertType = 'warning';
    if (isSeller) {
      alertMessage = I18n.t('commons.offers.estimatedValueAlert.sellerOutOfRange');
    } else {
      alertMessage = I18n.t('commons.offers.estimatedValueAlert.outOfRange');
    }
  } else {
    alertType = 'info';
  }

  return (
    <RCAlertBox
      type={alertType}
    >
      <strong>{I18n.t('commons.offers.estimatedValueAlert.label')}</strong> {recommendedLowPrice.display} - {recommendedHighPrice.display}
      {alertMessage && (
        <p>
          {alertMessage}
        </p>
      )}
    </RCAlertBox>
  );
}

export default EstimatedValueAlert;
